/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarkSubmissionListDto } from '../../models/survey-mark-submission-list-dto';

export interface ListSurveyMarksSubmissions$Params {
  lodge_status: Array<string>;
}

export function listSurveyMarksSubmissions(
  http: HttpClient,
  rootUrl: string,
  params: ListSurveyMarksSubmissions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarkSubmissionListDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    listSurveyMarksSubmissions.PATH,
    'get',
  );
  if (params) {
    rb.query('lodge_status', params.lodge_status, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarkSubmissionListDto>;
      }),
    );
}

listSurveyMarksSubmissions.PATH = '/me/surveyMarks/submissions';
